import React from "react";
import SpecialImage from "../assets/promise.png"; // Replace with your image
import "./Special.css";
import "../styles/main.css"; // Optional for custom styling

function Hero() {
  return (
    <section className="special-section container-fluid py-5">
      <div className="container">
        <div className="row align-items-center">

          <div className="col-12 col-md-6 text-center mb-4 mb-md-0 order-2 order-md-1">
            <img
              src={SpecialImage}
              alt="Our Promise"
              className="special-img img-fluid"
            />
          </div>

          <div className="col-12 col-md-6 text-center text-md-start order-1 order-md-2">
            <h2 className="special-title">Our Promise</h2>

            <div className="special-divider mx-md-0"></div>

            <p className="special-description">
               At EZ MedServ, our promise is simple to be more than just a service provider.
               We commit to delivering reliable, efficient, and cost-effective solutions that
               help your business grow. Backed by industry expertise, advanced technology, and
               a team of dedicated professionals, we ensure every task is handled with care and
              precision. Our goal is to save you time, reduce your costs, and improve performance
              while building a partnership based on trust and results.
            </p>
              <a href="#contact" className="btn btn-special-mobile me-3">
                <i className="fas fa-info-circle"></i> About Us
              </a>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Hero;